import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { CategoryService } from 'src/app/services/category.service';
import { Category } from 'src/app/models/category';
import { Course } from 'src/app/models/course';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-featured-courses',
  templateUrl: './featured-courses.component.html',
  styleUrls: ['./featured-courses.component.scss']
})
export class FeaturedCoursesComponent implements OnInit {
  private perPage=99999999;
  public loadingCourses: boolean = true;
  public courses:Course[];
  public availableFilters=[];
  private filterString='filter[deleted]=&filter[published]';
  public loadedCategories:boolean=false;
  public categories:Category[];
  public activeCategoryId:number;
  public coursesToAdd=[];
  public featuredCourses=[];
  public featuredCoursesLength:number=0;

  constructor(
    private _categories: CategoryService,
    private courseService: CourseService,
    private _notify: NotificationService
  ) { }

  ngOnInit() {
    this.getCourses(1);
    this.getCategories(1);
  }

  public getCategories(page){
    this._categories.getCategories().subscribe((cats:any) => {
      this.categories=cats;
      this.loadedCategories=true;
      this.activeCategoryId=this.categories[0].id;
    });
  }

  public getCourses(page){
    this.courseService.getActiveCourses().subscribe(res=>{
      this.courses=res;
      this.getSortFeaturedCourses();
      this.loadingCourses = false;
    })
  }

  private getSortFeaturedCourses(){
    this.featuredCourses=[];
    this.courses.forEach((course:any)=>{
      if(course.featured_order) {
        this.featuredCourses[course.featured_order]=course;
      }
    });
  }

  public updateCoursesToAdd(event:any){
    this.coursesToAdd=event.value;
  }

  public addFeaturedCourses(){
    let currentIndex=0;
    this.coursesToAdd.forEach((add:any)=>{
      this.updateCourse(add.id);
    });
  }

  private updateCourse(id:number){
    this.courses.forEach((course:any, index)=>{
      if(course.id==id) {
        this.courses[index].featured_order=this.featuredCourses.length+1;
      }
    });
    this.getSortFeaturedCourses();
  }

  public moveCourseUp(id:number,order:number){
    this.courses.forEach((course:any, index)=>{
      if(course.featured_order==(order-1)) this.courses[index].featured_order=order;
    });
    this.courses.forEach((course:any, index)=>{
      if(course.id==id) this.courses[index].featured_order=(order-1);
    });
    this.getSortFeaturedCourses();
  }

  public moveCourseDown(id:number,order:number){
    this.courses.forEach((course:any, index)=>{
      if(course.featured_order==(order+1)) this.courses[index].featured_order=order;
    });
    this.courses.forEach((course:any, index)=>{
      if(course.id==id) this.courses[index].featured_order=(order+1);
    });
    this.getSortFeaturedCourses();
  }

  public removeCourse(id:number){
    this.courses.forEach((course:any, index)=>{
      if(course.id==id) this.courses[index].featured_order=0;
    });
  }

  public updateFeaturedCourses(){
    let updateArray=[];
    this.courses.forEach((course:any)=>{
      if(course.featured_order && course.featured_order > 0) {
        updateArray.push({'id':course.id,'featured_order':course.featured_order});
      }
    });
    this.courseService.updateFeaturedCourses(updateArray).subscribe(
      (res:any)=>{
        if (res.message == 'updated') this._notify.showMessage('Featured courses updated.','OK');
      }
    );
  }
}
